import { IframeProps } from "@elements/Iframe/Iframe";
import { isThisUrlFrom } from "@helper/utils";

export default function IframeAttr(source: string): IframeProps {
  if (isThisUrlFrom(source, "omny")) {
    return {
      src: source,
    };
  }

  if (isThisUrlFrom(source, "dugout")) {
    return {
      src: decodeURIComponent(source),
      className: "absolute",
      addWrapper: true,
      wrapperAttr: {
        className: "relative pb-[60%]",
      },
      allowFullScreen: true,
    };
  }

  return {
    src: source,
  };
}
